import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/reports/vulnsreport/`;
export const QueryKey = (payload: Payload | undefined) => ['v3', 'reports', 'vulnsreport', payload].filter(Boolean);
export type Payload = {
    reporttype: `${Models.Reports.ReportType}`;
    size: number;
    sort: string;
    filter: Models.Reports.ReportFilter;
};

type Report =
    | Models.Reports.IpSummary
    | Models.Reports.ScanList
    | Models.Reports.VulnsList
    | Models.Reports.VulnsSummary;

export type Response<T extends Report = Report> = {
    report: Array<T>;
    totalCount: number;
};
